<content-loading *ngIf="isLoading"></content-loading>

<div class="box m-4" *ngIf="state.get('data').size">
  <form autocomplete="off" class="form m-0">
    <div class="columns">
      <div class="column is-7">
        <div class="field">
          <label class="label" translationEditableDirective="BUILDING_NAME">{{
            'BUILDING_NAME' | translate
          }}</label>
          <div class="control">
            <input
              *ngIf="!isReadonly"
              class="input is-small"
              name="name"
              type="text"
              (input)="handleFieldChange($event, null, ['building'])"
              [value]="getField(['building', 'name'])"
              [ngClass]="{ 'is-danger': hasError('name') }"
            />
            <span *ngIf="isReadonly">{{
              getField(['building', 'name']) || '-'
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('buildingName')">
            {{ getError('name') }}
          </p>
        </div>
        <div class="columns mb-0">
          <div class="column is-8 pb-0">
            <div class="field">
              <label class="label" translationEditableDirective="STREET">{{
                'STREET' | translate
              }}</label>
              <div class="control">
                <ng-select
                  *ngIf="!isReadonly"
                  [items]="streets"
                  name="street"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  (change)="handleFieldChange($event, 'street', ['building'])"
                  [ngClass]="{ 'is-danger': hasError('street') }"
                  bindLabel="name"
                  [typeahead]="onStreetsAutocomplete$"
                  [ngModel]="getField(['building', 'street']) | array"
                  class="is-small"
                >
                </ng-select>
                <span *ngIf="isReadonly">{{
                  getField(['building', 'street', 'name'])
                }}</span>
              </div>
              <p class="help is-danger" *ngIf="hasError('street')">
                {{ getError('street') }}
              </p>
            </div>
          </div>
          <div class="column is-4 pb-0">
            <div class="field">
              <label
                class="label"
                translationEditableDirective="STREET_NUMBER"
                >{{ 'STREET_NUMBER' | translate }}</label
              >
              <div class="control">
                <input
                  *ngIf="!isReadonly"
                  class="input is-small"
                  name="streetNumber"
                  type="text"
                  (input)="handleFieldChange($event, null, ['building'])"
                  [value]="getField(['building', 'streetNumber'])"
                  [ngClass]="{ 'is-danger': hasError('streetNumber') }"
                />
                <span *ngIf="isReadonly">{{
                  getField(['building', 'streetNumber']) || '-'
                }}</span>
              </div>
              <p class="help is-danger" *ngIf="hasError('streetNumber')">
                {{ getError('streetNumber') }}
              </p>
            </div>
          </div>
        </div>
        <div class="columns mb-0">
          <div class="column is-8 pb-0">
            <div class="field">
              <label class="label" translationEditableDirective="COMMUNITY">{{
                'COMMUNITY' | translate
              }}</label>
              <div class="control">
                <ng-select
                  *ngIf="!isReadonly"
                  name="community"
                  [items]="communities"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  (change)="
                    handleFieldChange($event, 'community', ['building'])
                  "
                  [ngClass]="{ 'is-danger': hasError('community') }"
                  bindLabel="name"
                  [typeahead]="onCommunitiesAutocomplete$"
                  [ngModel]="getField(['building', 'community']) | array"
                  class="is-small"
                >
                </ng-select>
                <span *ngIf="isReadonly">{{
                  getField(['building', 'community', 'name'])
                }}</span>
              </div>
              <p class="help is-danger" *ngIf="hasError('community')">
                {{ getError('community') }}
              </p>
            </div>
          </div>
          <div class="column is-4 pb-0">
            <!-- <div class="field">
              <label
                class="label"
                translationEditableDirective="NUMBER_OF_FLOORS"
                >{{ 'NUMBER_OF_FLOORS' | translate }}</label
              >
              <div class="control">
                <input
                  *ngIf="!isReadonly"
                  class="input is-small"
                  name="numberOfStories"
                  type="number"
                  (input)="handleFieldChange($event, null, ['building'])"
                  [value]="getField(['building', 'numberOfStories'])"
                  [ngClass]="{ 'is-danger': hasError('numberOfStories') }"
                />
                <span *ngIf="isReadonly">{{
                  getField(['building', 'numberOfStories'])
                }}</span>
              </div>
              <p class="help is-danger" *ngIf="hasError('numberOfStories')">
                {{ getError('numberOfStories') }}
              </p>
            </div> -->
          </div>
        </div>
      </div>
      <div class="column is-5 right-column">
        <div class="field">
          <label class="label" translationEditableDirective="DISCOUNT_GROUPS">{{
            'DISCOUNT_GROUPS' | translate
          }}</label>
          <div class="control">
            <ng-select
              [items]="discountGroups"
              [multiple]="true"
              *ngIf="!isReadonly"
              [closeOnSelect]="false"
              (change)="handleFieldChange($event, 'discountGroups')"
              [ngClass]="{ 'is-danger': hasError('discountGroups') }"
              [ngModel]="getField(['discountGroups']) | array"
              [ngModelOptions]="{ standalone: true }"
              bindLabel="name"
              class="is-small"
            >
            </ng-select>
            <span *ngIf="isReadonly">{{
              getDiscountGroups(getField(['discountGroups'])) || '-'
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('discountGroups')">
            {{ getError('discountGroups') }}
          </p>
        </div>

        <div class="field">
          <label class="label" translationEditableDirective="ASSESSABLE">{{
            'ASSESSABLE' | translate
          }}</label>
          <div class="control">
            <ng-select
              [readOnly]="isTranslationActive"
              *ngIf="!isReadonly"
              name="assessibility"
              [items]="assessableTypes"
              [multiple]="false"
              [closeOnSelect]="true"
              (change)="handleFieldChange($event, 'assessibility')"
              [ngClass]="{ 'is-danger': hasError('assessibility') }"
              [ngModel]="getField(['assessibility']) | array"
              class="is-small"
              [translationEditableModalDirective]="assessableTypeKeys"
              [translationEditableModalDirectiveDefaults]="
                assessableTypeDefaults
              "
            >
              <ng-template ng-label-tmp let-item="item">
                {{
                  item.translationKey | translate : { defaultValue: item.title }
                }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{
                  item.translationKey | translate : { defaultValue: item.title }
                }}
              </ng-template>
            </ng-select>
            <span
              *ngIf="isReadonly"
              [translationEditableDirective]="
                getField(['assessibility', 'translationKey'])
              "
              [translationEditableDirectiveDefault]="
                getField(['assessibility', 'title'])
              "
              >{{
                getField(['assessibility', 'translationKey'])
                  | translate
                    : { defaultValue: getField(['assessibility', 'title']) }
              }}</span
            >
          </div>
          <p class="help is-danger" *ngIf="hasError('assessibility')">
            {{ getError('assessibility') }}
          </p>
        </div>

        <div class="field">
          <label
            class="label"
            translationEditableDirective="ASSOCIATED_LICENSES"
            >{{ 'ASSOCIATED_LICENSES' | translate }}</label
          >
          <div
            class="control is-flex is-justify-content-start"
            style="align-items: center"
          >
            <span
              translationEditableDirective="NONE"
              *ngIf="businesses.length === 0"
              >{{ 'NONE' | translate }}</span
            >
            <button
              *ngIf="businesses.length !== 0"
              class="button is-ghost p-0"
              (click)="licensesModalVisible = true"
              translationEditableDirective="SHOW"
              style="height: auto"
            >
              {{ 'SHOW' | translate }}
            </button>
          </div>
        </div>

        <div class="field">
          <label class="label" translationEditableDirective="COMPOUND">{{
            'COMPOUND' | translate
          }}</label>
          <div
            class="control is-flex is-justify-content-start"
            style="align-items: center"
          >
            <span
              *ngIf="!hasCompoundPermission || !getField(['compound'])"
              [title]="getField(['compound', 'name']) || ''"
              >{{ getField(['compound', 'code']) || '-' }}</span
            >

            <a
              [routerLink]="['/compounds', getField(['compound', 'id'])]"
              class=""
              *ngIf="getField(['compound']) && hasCompoundPermission"
              >{{ getField(['compound', 'code']) }}</a
            >

            <span
              *ngIf="!!getField(['compound', 'primary'])"
              title="{{ 'PRIMARY' | translate }}"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#48c845"
                width="20px"
                class="ml-2 is-block"
                style="margin-top: -2px"
              >
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                />
              </svg>
            </span>
            <span
              *ngIf="
                !getField(['compound', 'primary']) && !!getField(['compound'])
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#dbdbdb"
                width="20px"
                class="ml-2 is-block"
                style="margin-top: -2px"
              >
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="px-4 mb-4">
  <article class="message is-warning" *ngIf="getField(['appeal', 'note'])">
    <div class="message-body">
      <strong translationEditableDirective="APPEAL_NOTE">{{
        'APPEAL_NOTE' | translate
      }}</strong
      >:
      <span [translationEditableDirective]="getField(['appeal', 'note'])">{{
        getField(['appeal', 'note'])
      }}</span>
    </div>
  </article>
  <article class="message is-info" *ngIf="getField(['appeal', 'fieldVisit'])">
    <div class="message-body">
      <strong translationEditableDirective="FIELD_VISIT_INSTRUCTIONS">{{
        'FIELD_VISIT_INSTRUCTIONS' | translate
      }}</strong
      >:
      <span
        [translationEditableDirective]="
          getField(['appeal', 'fieldVisitComment'])
        "
        >{{ getField(['appeal', 'fieldVisitComment']) | translate }}</span
      >
    </div>
  </article>
  <article class="message is-link" *ngIf="getField(['appeal', 'resolution'])">
    <div class="message-body">
      <strong translationEditableDirective="APPEAL_RESOLUTION">{{
        'APPEAL_RESOLUTION' | translate
      }}</strong
      >:
      <span
        [translationEditableDirective]="getField(['appeal', 'resolution'])"
        >{{ getField(['appeal', 'resolution']) }}</span
      >
    </div>
  </article>
  <article class="message is-info" *ngIf="getField(['returnReason'])">
    <div class="message-body">
      <strong translationEditableDirective="RETURN_REASON">{{
        'RETURN_REASON' | translate
      }}</strong
      >:
      <span [translationEditableDirective]="getField(['returnReason'])">{{
        getField(['returnReason'])
      }}</span>
    </div>
  </article>
</div>

<div class="modal is-active" *ngIf="licensesModalVisible">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="ASSOCIATED_LICENSES"
        >{{ 'ASSOCIATED_LICENSES' | translate }}</span
      >
      <button
        class="delete"
        (click)="licensesModalVisible = false"
        aria-label="close"
      ></button>
    </div>
    <div
      class="modal-card-body"
      style="border-bottom-left-radius: 6px; border-bottom-right-radius: 6px"
    >
      <table class="table is-hoverable">
        <thead>
          <tr>
            <th>{{ 'CODE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let business of businesses">
            <td>
              <a
                [href]="'/licenses/' + business.id"
                target="_blank"
                rel="noopener noreferrer"
                >{{ business.code }}</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
